import React, { Component } from 'react';
import classNames from 'classnames';
import { withContext } from '../utils/StateProvider';
import FacilityFrame from './facilityFrame';
import FacilityCharacters from './facilityCharacters';
import { teachableTo } from '../utils/combat/spells';

// The magic school. It teaches one pupil at a time: pick a character and the
// board shows what their own order will teach them, and nothing else.
class MagicSchool extends Component {

  handleKeydown = (e) => {
    const { party, chooseFacilityCharacter } = this.props.context;
    const slot = parseInt(e.key, 10) - 1;
    if (slot >= 0 && slot < party.length) chooseFacilityCharacter(slot);
  }

  // Why there is nothing on the board for this pupil
  emptyBoard(pupil) {
    if (!pupil.maxSp) return `${pupil.name} has no gift for magic.`;
    if (pupil.condition === 'dead') return `${pupil.name} is past teaching.`;
    return `${pupil.name} already knows everything taught here.`;
  }

  render() {
    const { facility, party, facilityCharacter, gold, learnSpell } = this.props.context;
    if (facility !== 'magic') return null;
    const pupil = party[facilityCharacter];
    const lessons = teachableTo(pupil);

    return (
      <FacilityFrame
        title="The Magic School"
        quote='"Knowledge is freely given. The ink, however, is expensive."'
        hint="Click a name or press 1-6 to sit someone else down"
        onKey={this.handleKeydown}
      >
        <FacilityCharacters />
        <div className="facility-standing">
          {pupil.name} · {pupil.className} {pupil.level}
          {pupil.maxSp > 0 && ` · ${pupil.sp}/${pupil.maxSp} SP`}
          {pupil.spells.length > 0 && ` · knows ${pupil.spells.length} spell${pupil.spells.length > 1 ? 's' : ''}`}
        </div>

        <div className="training-list">
          {lessons.map((spell) => (
            <div key={spell.id} className={classNames('training-row', { ready: gold >= spell.price })}>
              <div className="training-who">
                <div className="training-name">{spell.name}</div>
                <div className="sheet-muted">{spell.description} · {spell.cost(pupil)} SP to cast</div>
              </div>
              <button
                className={classNames('menu-button', 'small', { disabled: gold < spell.price })}
                onClick={() => learnSpell(facilityCharacter, spell.id)}
              >
                LEARN · {spell.price}g
              </button>
            </div>
          ))}

          {!lessons.length && <div className="sheet-muted sheet-empty">{this.emptyBoard(pupil)}</div>}
        </div>
      </FacilityFrame>
    );
  }
}

export default withContext(MagicSchool);
